import React, { useState, useEffect } from 'react';
import { FaBirthdayCake, FaCheck, FaTimes } from 'react-icons/fa';

const AgeVerification: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    const verified = localStorage.getItem('ageVerified');
    if (verified !== 'true') {
      setIsVisible(true);
    } else {
      setIsVerified(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setIsVerified(true);
    setIsVisible(false);
  };

  const handleDecline = () => {
    window.location.href = 'https://www.google.com';
  };

  if (!isVisible || isVerified) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-sm animate-fade-in">
      <div className="glass rounded-2xl p-8 max-w-md mx-4 animate-slide-up">
        <div className="text-center space-y-6">
          <div className="flex justify-center">
            <div className="bg-accent-primary/20 p-4 rounded-full">
              <FaBirthdayCake className="text-accent-primary" size={48} />
            </div>
          </div>
          <div>
            <h2 className="text-2xl font-bold text-white mb-2">Vérification de l'âge</h2>
            <p className="text-gray-300">
              Vous devez avoir au moins 18 ans pour accéder à ce site.
            </p>
          </div>
          <div className="space-y-3">
            <button
              onClick={handleConfirm}
              className="w-full bg-accent-primary hover:bg-accent-primary/90 text-white font-semibold py-3 px-6 rounded-lg transition-all flex items-center justify-center space-x-2"
            >
              <FaCheck />
              <span>J'ai plus de 18 ans</span>
            </button>
            <button
              onClick={handleDecline}
              className="w-full bg-dark-card hover:bg-dark-hover text-gray-300 font-semibold py-3 px-6 rounded-lg transition-all flex items-center justify-center space-x-2"
            >
              <FaTimes />
              <span>J'ai moins de 18 ans</span>
            </button>
          </div>
          <p className="text-gray-400 text-xs">
            En continuant, vous confirmez que vous êtes majeur et que vous acceptez nos conditions
            d'utilisation.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AgeVerification;

